import React from 'react'
import { Row, Col, Input, Collapse, CardBody } from "reactstrap";
import { formatDate } from "../../../../Utils/format-date.js";
import Layout from "../../Layout/Layout";
import Modal from "../../../../Components/Modals/modal";
import CreateGoal from "../Create-Goal-Modal/Create-Goal";
import EditGoal from "../Edit-Goal/EditGoal";
import GoalSettingWorksheetsLogo from "../../../../../images/new-images/goalseetingworksheet.png";
import Edit from "../../../../../images/new-images/edit-green.svg";
import "./Goal-Setting-Worksheets.css";

const GoalSettingWorksheets = (props) => {
    return (
      <Layout
        headerIcon={GoalSettingWorksheetsLogo}
        headerText="My Worksheet"
        button="CREATE WORKSHEET"
        click={props.handleCreateModal}
      >
        <div className="my-resp-worksheet">
          <Modal
            assessmentModal={props.createModal}
            handleModalClose={props.handleModalClose}
            modalHeading="ADD WORKSHEET"
          >
            <CreateGoal
              date={props.date}
              handleModalClose={props.handleModalClose}
            />
          </Modal>

          <div className="search-bar">
            <input
              className="search-field"
              type="search"
              placeholder="Search..."
              onChange={(e) => props.handleSearchInput(e.target.value)}
            ></input>

            <Input
              className="drop-down"
              type="select"
              onChange={(e) => props.handleSelectOption(e.target.value)}
            >
              <option value="all">ALL</option>
              <option value="worksheet name">WORKSHEET NAME</option>
              <option value="orientation">ORIENTATION</option>
              <option value="assessment date">ASSESSMENT DATE</option>
            </Input>
          </div>

          {props.resp.map((tableData, index) => {
            return (
              <div key={index}>
                <Row>
                  <p
                    onClick={() => props.handleManageWorksheet(tableData)}
                    className="worksheet-name"
                  >
                    {tableData.worksheet_name}
                  </p>
                  <i
                    onClick={() => props.toggleCollapse(tableData.id)}
                    className={
                      props.collapseID === tableData.id
                        ? "fas fa-angle-up"
                        : "fa fa-angle-down"
                    }
                    aria-hidden="true"
                  />
                </Row>
                <Collapse isOpen={props.collapseID === tableData.id}>
                  <CardBody>
                    <Row>
                      <Col className="title">ORIENTATION </Col>
                      <Col className="details">
                        {tableData.orientation__orientation_name}
                      </Col>
                    </Row>
                    <Row>
                      <Col className="title"> DATE </Col>
                      <Col className="details">
                        {formatDate(tableData.assessment__created)}
                      </Col>
                    </Row>
                    <hr />
                    <div className="edit">
                      <img
                        onClick={() =>
                          props.handleEditModal(
                            tableData.worksheet_name,
                            tableData.orientation__orientation_name,
                            tableData.assessment__created
                          )
                        }
                        className="edit-icon"
                        src={Edit}
                      />
                    </div>
                    <Modal
                      assessmentModal={props.editModal}
                      handleModalClose={props.handleModalClose}
                      modalHeading="EDIT WORKSHEET"
                    >
                      <EditGoal
                        name={props.name}
                        orientation={props.orientation}
                        date={props.date}
                        handleModalClose={props.handleModalClose}
                      />
                    </Modal>
                  </CardBody>
                </Collapse>
                <hr />
              </div>
            );
          })}
        </div>
      </Layout>
    );
}

export default GoalSettingWorksheets;


// WEBPACK FOOTER //
// ./src/new/Dashboard/Admin/Goal-Setting-Worksheets/Responsive/Goal-Setting-Worksheets.jsx